/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'membership-card-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M23 2H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-7.719 12L12.5 12.463 9.719 14l.531-3.256L8 8.438l3.11-.475L12.5 5l1.39 2.963 3.11.475-2.25 2.306zM8 25l4-1.778V19H8v6zM13 23.222L17 25v-6h-4v4.222z"/>'
  }
})
